<nav class="navbar navbar-vertical navbar-expand-md navbar-dark sidebar-modern" id="sidenav-main">
  <div class="container-fluid">
    <!-- Toggler -->
    <button class="navbar-toggler" type="button" (click)="isCollapsed=!isCollapsed"
      aria-controls="sidenav-collapse-main">
      <span class="navbar-toggler-icon"></span>
    </button>
    <!-- Brand -->
    <a class="navbar-brand pt-0" routerLinkActive="active" [routerLink]="['/'+mainPath]">
      <img src="./assets/img/brand/white.png" class="navbar-brand-img" alt="...">
    </a>
    <!-- User -->
    <ul class="nav align-items-center d-md-none">
      <li class="nav-item" appDropdown>
        <a class="nav-link" role="button" appDropdownToggle>
          <div class="media align-items-center">
            <span class="avatar avatar-sm rounded-circle">
              @if (!sessionIsOpen) {
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="100%"
                  height="100%">
                  <circle cx="20" cy="20" r="20" fill="#5e72e4" />
                  <circle cx="20" cy="16" r="7" fill="#fff" />
                  <ellipse cx="20" cy="34" rx="12" ry="8" fill="#fff" />
                </svg>
              }
              @if (sessionIsOpen) {
                <img alt="Image placeholder" [src]="avatarUrl">
              }
            </span>
          </div>
        </a>
        <div class="dropdown-menu-arrow dropdown-menu-right" appDropdownMenu>
          @if (sessionIsOpen && !isAppType) {
            <a routerLinkActive="active" [routerLink]="['/'+profilePath]" class="dropdown-item">
              <i class="sdx sdx-user"></i>
              <span>{{ 'label.profile' | transloco }}</span>
            </a>
          }
          <button class="dropdown-item" (click)="openLanguageModal()">
            <span class="avatar avatar-xs rounded-circle">
              <img alt="Image Lang" src="{{ langIcon }}">
            </span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;{{ 'language.title' | transloco }}</span>
          </button>
          <!--a routerLinkActive="active" [routerLink]="['/'+supportPath]" class="dropdown-item">
            <i class="sdx sdx-support"></i>
            <span>{{ 'label.support' | transloco }}</span>
          </a-->
          <div class="dropdown-divider"></div>
          @if (sessionIsOpen) {
            <button class="dropdown-item" (click)="closeSession()">
              <i class="sdx sdx-door-closed"></i>
              <span>{{ 'label.close' | transloco }}</span>
            </button>
          }
          @if (!sessionIsOpen) {
            <a [routerLink]="['/'+loginPath]" class="dropdown-item">
              <i class="sdx sdx-door-open"></i>
              <span>{{ 'login.button' | transloco }}</span>
            </a>
          }
        </div>
      </li>
    </ul>
    <!-- Collapse -->
    <div class="collapse navbar-collapse" [class.show]="!isCollapsed" id="sidenav-collapse-main">
      <!-- Collapse header -->
      <div class="navbar-collapse-header d-md-none">
        <div class="row">
          <div class="col-6 collapse-brand">
            <a routerLinkActive="active" [routerLink]="['/'+mainPath]">
              <img src="./assets/img/brand/white.png">
            </a>
          </div>
          <div class="col-6 collapse-close">
            <button type="button" class="navbar-toggler" (click)="isCollapsed=!isCollapsed">
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>
      <!-- Heading -->
      @if (menuItems!.length > 0) {
        <div>
          <h6 class="navbar-heading text-muted">{{ 'label.menu' | transloco }}</h6>
          <!-- Navigation -->
          <ul class="navbar-nav">
            @for (pageItem of menuItems; track $index) {
            <li class="{{pageItem.class}} nav-item">
              <a routerLinkActive="active" [routerLink]="['/'+pageItem.path]" class="nav-link">
                <i class="sdx {{pageItem.icon}}"></i>
                {{ pageItem.title | transloco }}
              </a>
            </li>
            }
            @if (sessionIsOpen && !isSuperUser) {
              <div>
                @for (pageItem of publicItems; track $index) {
                <li class="{{pageItem.class}} nav-item">
                  <a routerLinkActive="active" [routerLink]="['/'+pageItem.path]" class="nav-link">
                    <i class="sdx {{pageItem.icon}}"></i>
                    {{ pageItem.title | transloco }}
                  </a>
                </li>
                }
              </div>
            }
          </ul>
        </div>
      }

      @if (sessionIsOpen && isSuperUser && adminItems!.length > 0) {
        <div>
          <!-- Divider -->
          <hr class="my-3">
          <!-- Heading -->
          <h6 class="navbar-heading text-muted">{{ 'label.administration' | transloco }}</h6>
          <!-- Navigation -->
          <ul class="navbar-nav">
            @for (pageItem of adminItems; track $index) {
            <li class="{{pageItem.class}} nav-item">
              <a routerLinkActive="active" [routerLink]="['/'+pageItem.path]" class="nav-link">
                <i class="sdx {{pageItem.icon}}"></i>
                {{ pageItem.title | transloco }}
              </a>
            </li>
            }
          </ul>
        </div>
      }

      @if (sessionIsOpen && settingsItems!.length > 0) {
        <div>
          <!-- Divider -->
          <hr class="my-3">
          <!-- Heading -->
          <h6 class="navbar-heading text-muted">{{ 'label.settings' | transloco }}</h6>
          <!-- Navigation -->
          <ul class="navbar-nav">
            @for (pageItem of settingsItems; track $index) {
            <li class="{{pageItem.class}} nav-item">
              <a routerLinkActive="active" [routerLink]="['/'+pageItem.path]" class="nav-link">
                <i class="sdx {{pageItem.icon}}"></i>
                {{ pageItem.title | transloco }}
              </a>
            </li>
            }
          </ul>
        </div>
      }


    </div>
  </div>
</nav>
